import React, { useState, useEffect, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const MediaQuery = forwardRef((props, ref) => {
  const theme = useTheme();

  // eslint-disable-next-line prefer-const
  const { as, mediaQuery = `sm`, direction = 'up', ...otherProps } = props;
  let goodMQ = mediaQuery;
  if (mediaQuery.length < 4) {
    goodMQ = theme.breakpoints[direction](mediaQuery);
  }

  const doesMatch = useMediaQuery(goodMQ);
  const [shouldUseMediaQuery, setShouldUseMediaQuery] = useState(false);
  useEffect(() => {
    setShouldUseMediaQuery(true);
  }, []);

  if (shouldUseMediaQuery && !doesMatch) {
    return null;
  }

  // div inside button is not valid HTML
  // provide option to render span for a11y purposes
  if (as === 'span') {
    return <ContentSpan ref={ref} mediaQuery={goodMQ} {...otherProps} />;
  }

  return <ContentDiv ref={ref} mediaQuery={goodMQ} {...otherProps} />;
});

MediaQuery.snapshot = false;

const contentStyles = css`
  display: none;

  ${({ mediaQuery }) => mediaQuery} {
    display: ${({ display = 'inherit' }) => display};
  }
`;

const ContentDiv = styled.div`
  ${contentStyles}
`;

const ContentSpan = styled.span`
  ${contentStyles}
`;

export default MediaQuery;
